import { Component, ViewChild } from '@angular/core';
import { iBisViewComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { FilterPatientService } from './filter-patient.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';

@Component({
    selector: 'app-filter-patient',
    templateUrl: './filter-patient.component.html',
    styleUrls: ['./filter-patient.component.scss']
})
export class FilterPatientComponent extends iBisViewComponent {
    @ViewChild('filterPatientGrid') declare grid: DxDataGridComponent;

    public declare edit: FilterPatientService;
    constructor(public proxy: ProxyService) {
        super(proxy.filterPatient, proxy.lg, proxy.iui, proxy.activatedRoute);
        this.key = '[MDS]FilterPatient';
    }

    onExporting(e: any) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Patients');

        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'patients.xlsx');
            });
        });

    }

    toolbarPreparing(event: any) {
        //super.toolbarPreparing(event, true);
        event.toolbarOptions.items.unshift({
            widget: 'dxButton',
            options: {
                text: this.L('GENERATE'),
                stylingMode: 'outlined',
                validationGroup: this.edit.validation,
                onClick: (e: any) => {
                    this.edit.generateData(e);
                }
            },
            location: 'after'
        });
    }

    OnSpecializationChanged = (e: any) => {
        if (e.event) {
            const specIds = e.value.map((item: any) => item.id);
            this.edit.getDoctorsBySpec(specIds)
        }
    }

}
